import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, Toaster, TooltipProvider } from '@xinfer/ui';
import { App } from './App';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Usage and keys change rarely; refetching on every focus is noise.
      refetchOnWindowFocus: false,
      staleTime: 15_000,
    },
  },
});

const root = document.getElementById('root');
if (!root) {
  throw new Error('missing #root');
}

createRoot(root).render(
  <React.StrictMode>
    <ThemeProvider>
      {/* One provider for the whole app, so moving the pointer between two
          tooltips does not wait out the open delay a second time. */}
      <TooltipProvider delayDuration={200}>
        <QueryClientProvider client={queryClient}>
          {/* The portal is served from the origin root, so there is no
              basename. The admin bundle is the one that needs one. */}
          <BrowserRouter>
            <App />
          </BrowserRouter>
          <Toaster />
        </QueryClientProvider>
      </TooltipProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
